import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import "./Header.scss";
import messages from '../../assets/i18n'
import logoRenner from "../../assets/images/logos/logo-lojas-renner.svg";
import getEnvParam from "../../utils/getEnvParam";
import { FlagChoice } from "..";

function Header(props) {
    const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);
    const showTags = props.showTags === false ? false : true; 

    const context = useSelector(state => state.authentication.context);

    const logout = () => {
        dispatch({
            type: 'LOGOUT_REQUEST',
        });
        window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'logout';
    }

    return (
        <Container fluid className="header">
            <Row className="grid max-width">
                <Col className="d-flex align-items-center align-content-center">
                    <div className="mr-2 name-portal">
                        {messages[lang].initialPortal}
                    </div>
                    <div className="text-left pl-2">
                        <img
                            className="logo"
                            width="130"
                            src={logoRenner}
                            alt={messages[lang].lojasRennerLtda}
                            title={messages[lang].lojasRennerLtda}
                        />
                    </div>
                    {   
                        context && context.nome &&
                        <div className="mr-2 name-portal">
                            {context.nome} | {context.chapa}
                        </div>
                    }
                </Col>

                {
                    showTags && 
                    <Col className="d-flex align-items-center align-content-center justify-content-end">
                        <div>
                            <FlagChoice />
                        </div>
                        <div>
                            <Button className="logout" type="button" onClick={logout}>{messages[lang].Logout}</Button>
                        </div>
                    </Col>
                }
            </Row>
        </Container>
    );
}

export default Header;
